import { render, staticRenderFns } from "./agenteia-documentos.vue?vue&type=template&id=119e879b&scoped=true"
import script from "./agenteia-documentos.vue?vue&type=script&lang=js"
export * from "./agenteia-documentos.vue?vue&type=script&lang=js"
import style0 from "./agenteia-documentos.vue?vue&type=style&index=0&id=119e879b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119e879b",
  null
  
)

export default component.exports